import { connect } from 'react-redux'
import { addProductToCart } from './actions'
import { compose } from 'recompose'
import withShoppingData from 'components/common/hoc/withShoppingData/withShoppingData'
import withFavoritesData from 'components/MyFavorites/withFavoritesData'

const mapDispatchToProps = (dispatch, { productInfo }) => ({
  onClick() {
    dispatch(addProductToCart(productInfo))
  }
})

export default compose(
  withShoppingData,
  withFavoritesData,
  connect(null, mapDispatchToProps)
)
